























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Profile = namespace('Profile');

@Component
export default class ProfileConnector extends Vue {
  public profileLoading: boolean = false;

  @Profile.State
  public balance!: number;

  @Profile.State
  public bank!: string;

  @Profile.State
  public refCode!: string;

  @Profile.State
  public accountNumber!: string;

  @Profile.State
  public accountName!: string;

  @Profile.State
  public username!: string;

  @Profile.State
  public affiliateRevenue!: number;

  @Profile.State
  public totalDeposit!: number;

  @Profile.State
  public totalWithdraw!: number;

  @Profile.State
  public lastWeekTotalDeposit!: number;

  @Profile.State
  public lastWeekTotalWithdraw!: number;

  @Profile.State
  public ufaUsername!: string;

  @Profile.Action
  public fetchBalance!: () => {}

  @Profile.Action
  public getProfile!: () => {}

  public async checkBalance() {
    this.profileLoading = true;
    await this.fetchBalance();
    await this.getProfile();
    this.profileLoading = false;
    this.$store.commit('Snackbar/showNotification', { message: 'ดึงข้อมูลสำเร็จ', error: false });
  }

  async created() {
    await this.fetchBalance();
    await this.getProfile();
  }
}
